module.exports = __webpack_public_path__ + "static/vicinity_logo-e4c1bf3c730cf5173c20f150ca40668b.png";